__turbopack_context__.v({
  "card": "_7qzP6G_card",
  "checklist": "_7qzP6G_checklist",
  "checklistItem": "_7qzP6G_checklistItem",
  "checklistLabel": "_7qzP6G_checklistLabel",
  "chooseButton": "_7qzP6G_chooseButton",
  "compareArrowWrap": "_7qzP6G_compareArrowWrap",
  "compareDivider": "_7qzP6G_compareDivider",
  "compareFooter": "_7qzP6G_compareFooter",
  "compareLink": "_7qzP6G_compareLink",
  "description": "_7qzP6G_description",
  "glpIncludeBody": "_7qzP6G_glpIncludeBody",
  "glpIncludeDivider": "_7qzP6G_glpIncludeDivider",
  "glpIncludeItem": "_7qzP6G_glpIncludeItem",
  "glpIncludeTag": "_7qzP6G_glpIncludeTag",
  "glpIncludeTagQuantity": "_7qzP6G_glpIncludeTagQuantity",
  "glpIncludeTitle": "_7qzP6G_glpIncludeTitle",
  "glpIncludeTitleRow": "_7qzP6G_glpIncludeTitleRow",
  "glpIncludesClickArea": "_7qzP6G_glpIncludesClickArea",
  "glpIncludesList": "_7qzP6G_glpIncludesList",
  "glpPricingTierLabel": "_7qzP6G_glpPricingTierLabel",
  "headerBlock": "_7qzP6G_headerBlock",
  "iconWrapper": "_7qzP6G_iconWrapper",
  "includeThumbnail": "_7qzP6G_includeThumbnail",
  "includesBlock": "_7qzP6G_includesBlock",
  "includesHeader": "_7qzP6G_includesHeader",
  "includesWrapper": "_7qzP6G_includesWrapper",
  "journeyFooterLink": "_7qzP6G_journeyFooterLink",
  "originalPrice": "_7qzP6G_originalPrice",
  "planName": "_7qzP6G_planName",
  "planTag": "_7qzP6G_planTag",
  "price": "_7qzP6G_price",
  "priceGroup": "_7qzP6G_priceGroup",
  "priceRow": "_7qzP6G_priceRow",
  "titlePriceGroup": "_7qzP6G_titlePriceGroup",
  "titleRow": "_7qzP6G_titleRow",
});
